import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class QuarryFlooded1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.QUARRY_FLOODED1;
}

export default QuarryFlooded1PoiTileEntity;
